import { useState } from "react";
import { toast } from "sonner";
import { subscribeNewsletter } from "../lib/api";
import { Mail } from "lucide-react";

export default function Newsletter({ dark = false }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await subscribeNewsletter({ email });
      toast.success("You're on the list — welcome to the brotherhood.");
      setEmail("");
    } catch {
      toast.error("Something went wrong. Try again in a moment.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="flex flex-col gap-3 sm:flex-row" data-testid="newsletter-form">
      <div className={`flex flex-1 items-center gap-2 rounded-md border px-4 py-3 ${dark ? "border-white/20 bg-white/5" : "border-black/15 bg-white"}`}>
        <Mail className={`h-4 w-4 ${dark ? "text-white/60" : "text-black/50"}`} />
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email address"
          data-testid="newsletter-email"
          className={`w-full bg-transparent text-sm outline-none ${dark ? "text-white placeholder:text-white/50" : "text-black placeholder:text-black/50"}`}
        />
      </div>
      <button type="submit" disabled={loading} data-testid="newsletter-submit" className="btn-gold min-w-[8rem]">
        {loading ? "…" : "Subscribe"}
      </button>
    </form>
  );
}
